import { render } from "./UserMenuButton.vue?vue&type=template&id=13be0be0&scoped=true"
import script from "./UserMenuButton.vue?vue&type=script&lang=js"
export * from "./UserMenuButton.vue?vue&type=script&lang=js"

import "./UserMenuButton.vue?vue&type=style&index=0&id=13be0be0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13be0be0"]])

export default __exports__